import { defineMessages } from 'react-intl';
import { Message } from '../../../types/Message';

interface MessagesProp {
  [key: string]: Message;
}

export const messages: MessagesProp = defineMessages({
  quoteNumberPrefix: {
    id: 'quotes.list.quoteNumberPrefix',
    defaultMessage: 'Quote',
  },
  quoteTitle: {
    id: 'quotes.list.quoteTitle',
    defaultMessage: 'Quote',
  },
  quoteDetailsPage: {
    id: 'quotedetails.page.seo.title',
    defaultMessage: 'Quote details page',
  },
  initial: {
    id: 'quotes.status.initial',
    defaultMessage: 'initial',
  },
  expired: {
    id: 'quotes.status.expired',
    defaultMessage: 'expired',
  },
  released: {
    id: 'quotes.status.released',
    defaultMessage: 'released',
  },
  created: {
    id: 'quotes.status.created',
    defaultMessage: 'created',
  },
  published: {
    id: 'quotes.status.published',
    defaultMessage: 'Published',
  },
  withdrawn: {
    id: 'quotes.status.withdrawn',
    defaultMessage: 'Withdrawn',
  },
  quoteListErrorTitle: {
    id: 'quotes.page.empty.noQuotesFound.title',
    defaultMessage: 'We could not find any quotes.',
  },
  quoteListErrorDescription: {
    id: 'quotes.page.empty.noQuotesFound.description',
    defaultMessage: 'Don\'t hesitate to {contactLink} us for a new quote.',
  },
  quoteContactUrl: {
    id: 'quotes.page.empty.noQuotesFound.contactUrl',
    defaultMessage: '/nl/pages/offerte-aanvragen',
  },
});
